import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4b82286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newreceiverfinalpairing text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "receiver-icon",
  viewBox: "0 0 128 128",
  "data-test": "receiver-type-apple4-icon"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", { d: "M24.3,68.3h77.5c6.4,0,19.4-4.5,14.2-13.6c-3.3-5.8-7-10.7-10.7-15.1c-4.3-5.1-8.4-6.7-23.5-6.5H44.1\n                        C29,32.9,24,35,20.6,39.6c-3.4,4.6-7.2,9.3-10.5,15.1C4.8,63.9,17.9,68.3,24.3,68.3" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M71,74.8h27.9c6.7,0,17.5-2.4,18.2-7c0,0-2.4,13.3-3.6,18.7C111.7,95,97.4,95,93.8,95H69.5h-3H32.2c-3.6,0-17.9,0-19.8-8.5\n                        c-1.2-5.4-3.6-18.7-3.6-18.7c0.7,4.6,11.5,7,18.2,7h37.8C64.9,74.8,71,74.8,71,74.8z" })
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { "data-test": "receiver-type-apple4-heading" }, "Apple TV HD /4K", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-pair-tv-os-heading" }, "Pair Ditto tvOS Receiver with a Code", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "pair-instructions-list mt-2",
  "data-test": "receiver-pair-tv-os-list"
}, [
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-pair-tv-os-list-item-1" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "1"),
    /*#__PURE__*/_createTextVNode(". Select "),
    /*#__PURE__*/_createElementVNode("strong", null, "App Store"),
    /*#__PURE__*/_createTextVNode(" from the Apple TV home screen.")
  ]),
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-pair-tv-os-list-item-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "2"),
    /*#__PURE__*/_createTextVNode(". In the App Store, search for "),
    /*#__PURE__*/_createElementVNode("strong", null, "Ditto"),
    /*#__PURE__*/_createTextVNode(", find our app, then select "),
    /*#__PURE__*/_createElementVNode("strong", null, "Get"),
    /*#__PURE__*/_createTextVNode(" to start installation.")
  ]),
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-pair-tv-os-list-item-3" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "3"),
    /*#__PURE__*/_createTextVNode(". After installation, the Ditto app will appear on the home screen. Open it.")
  ]),
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-pair-tv-os-list-item-4" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "4"),
    /*#__PURE__*/_createTextVNode(". A pairing code will appear. Enter the code here.")
  ])
], -1))
const _hoisted_7 = { class: "col-md-6 p-0 ps-md-2 mb-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "pair-ditto-receiver-tv-os-heading" }, "Pair Ditto Receiver", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-open-app-to-get-code-text" }, [
  /*#__PURE__*/_createTextVNode("Open the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Receiver app"),
  /*#__PURE__*/_createTextVNode(" on your receiving device to get the pairing code.")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-tv-os-click-pair-to-finish-text" }, "Click Pair to finish", -1))
const _hoisted_11 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "receiver-icon",
  viewBox: "0 0 128 128",
  "data-test": "receiver-type-windows-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.5,100.6l41.5,6V66.8H12.5V100.6z M12.5,61.2h41.5V21.4l-41.5,6V61.2z M59.7,107.4l55.7,8.1V66.8H59.7V107.4z\n                                M59.7,20.6v40.6h55.7V12.5L59.7,20.6z" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { "data-test": "receiver-type-windows-heading" }, "Windows", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-type-windows-text" }, [
  /*#__PURE__*/_createTextVNode("There are "),
  /*#__PURE__*/_createElementVNode("strong", null, "two ways"),
  /*#__PURE__*/_createTextVNode(" to add the Ditto Windows Receiver. ")
], -1))
const _hoisted_16 = { class: "row text-left mt-5 windows-pairing-options" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-option-one-heading" }, "Option One", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-form-item__description",
  "data-test": "receiver-type-windows-option-one-description"
}, "Pair Ditto Receiver with Registry Key", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-form-item__description",
  "data-test": "receiver-type-windows-option-one-text"
}, [
  /*#__PURE__*/_createElementVNode("em", null, "Download a registry key, deploy it to a computer with Ditto Receiver and it will automatically associate itself to this receiver.")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-name-heading" }, "Receiver Name", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click Generate Pairing Registry Key to finish.", -1))
const _hoisted_22 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This option allows you to deploy the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Windows Receiver"),
  /*#__PURE__*/_createTextVNode(" remotely.")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-option-two-heading" }, "Option Two", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-option-two-description" }, "Pair Ditto Windows Receiver with a Code", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "pair-instructions-list",
  "data-test": "receiver-type-windows-option-two-list"
}, [
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-type-windows-option-two-list-item-1" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "1"),
    /*#__PURE__*/_createTextVNode(". Download and install the Ditto Windows Receiver app on your Windows device. "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "link",
      href: "https://www.airsquirrels.com/ditto/download",
      target: "_blank",
      rel: "noreferrer noopener",
      "data-test": "receiver-type-windows-option-two-download-ditto-link"
    }, "Download Ditto")
  ]),
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-type-windows-option-two-list-item-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "2"),
    /*#__PURE__*/_createTextVNode(". Launch the Ditto Windows Receiver")
  ]),
  /*#__PURE__*/_createElementVNode("li", { "data-test": "receiver-type-windows-option-two-list-item-3" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "3"),
    /*#__PURE__*/_createTextVNode(". A pairing code will appear. Enter the code here.")
  ])
], -1))
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-option-two-pairing-code-heading" }, "Pairing Code", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Open the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Receiver app"),
  /*#__PURE__*/_createTextVNode(" on your receiving device to get the pairing code.")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-type-windows-option-two-click-pair-text" }, "Click Pair to finish.", -1))
const _hoisted_31 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  key: 0,
  class: "receiver-icon",
  viewBox: "0 0 128 128",
  "data-test": "receiver-type-apple3-icon"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24.3,68.3h77.5c6.4,0,19.4-4.5,14.2-13.6c-3.3-5.8-7-10.7-10.7-15.1c-4.3-5.1-8.4-6.7-23.5-6.5H44.1\n                    C29,32.9,24,35,20.6,39.6c-3.4,4.6-7.2,9.3-10.5,15.1C4.8,63.9,17.9,68.3,24.3,68.3" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M71,74.8h27.9c6.7,0,17.5-2.4,18.2-7c0,0-2.4,13.3-3.6,18.7C111.7,95,97.4,95,93.8,95H69.5h-3H32.2c-3.6,0-17.9,0-19.8-8.5\n                    c-1.2-5.4-3.6-18.7-3.6-18.7c0.7,4.6,11.5,7,18.2,7h37.8C64.9,74.8,71,74.8,71,74.8z" })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "receiver-icon",
  viewBox: "0 0 128 128",
  "data-test": "receiver-type-chromecast-icon"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M85.4,46.5L85.4,46.5c-4.1-2.5-8.7-4.4-13.7-5.4V5.7c0-0.5-0.4-1-1-1H56.4c-0.5,0-1,0.4-1,1v35.4C36.4,44.9,22,61.7,22,81.9\n                c0,7.2,1.8,14,5.1,19.9l0,0c7.1,12.9,20.8,21.7,36.6,21.7c23,0,41.6-18.6,41.6-41.6C105.3,66.9,97.3,53.8,85.4,46.5z M67.3,63.7\n                L67.3,63.7c-1.2-0.2-2.4-0.4-3.6-0.4c0,0,0,0,0,0C64.9,63.3,66.1,63.5,67.3,63.7z M63.6,64.2c7,0,13,4,15.9,9.9H63.6\n                c-4.1,0-7.5,3.2-7.8,7.3l-6.1-10.4C53,66.8,58,64.2,63.6,64.2z M63.6,75.3c3.6,0,6.6,3,6.6,6.6c0,3.6-3,6.6-6.6,6.6s-6.6-3-6.6-6.6\n                C57,78.3,60,75.3,63.6,75.3z M45.9,81.9c0-3.7,1.1-7,3-9.9l7.3,12.5c1.1,3,4,5.2,7.4,5.2c1.3,0,2.5-0.3,3.6-0.9l-6.1,10.5\n                C52.5,98.2,45.9,90.8,45.9,81.9z M63.6,99.7c-0.4,0-0.8,0-1.2,0l8.1-13.9l0,0c0.6-1.1,1-2.4,1-3.8c0-2.8-1.4-5.2-3.6-6.6h12.2\n                c0.8,2,1.3,4.3,1.3,6.6C81.4,91.7,73.4,99.7,63.6,99.7z" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "receiver-icon",
  viewBox: "0 0 128 128",
  "data-test": "receiver-type-other-icon"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M17.2,78c-7.7,0-14-6.3-14-14s6.3-14,14-14s14,6.3,14,14S25,78,17.2,78z M49.8,64c0,7.7,6.3,14,14,14s14-6.3,14-14\n                    s-6.3-14-14-14S49.8,56.3,49.8,64z M96.4,64c0,7.7,6.3,14,14,14s14-6.3,14-14s-6.3-14-14-14S96.4,56.3,96.4,64z" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-other-name-text" }, "Enter a name for this receiver. For example, \"Conference Room Apple TV\".", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-other-connection-info-text" }, "Enter the connection information for the receiver.", -1))
const _hoisted_46 = { class: "row" }
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_49 = ["d"]
const _hoisted_50 = ["href"]
const _hoisted_51 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_52 = ["d"]
const _hoisted_53 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-other-connection-type-text" }, "Select a connection type for the receiver.", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click Create Receiver once all fields are filled.", -1))
const _hoisted_56 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "mt-2 mb-4 m-auto d-block",
      type: "text",
      onClick: _ctx.onPreviousStep,
      "data-test": "back-to-receiver-button"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          class: "primary-color me-1",
          small: "",
          icon: _ctx.mdiArrowLeft
        }, null, 8, ["icon"]),
        _createTextVNode("Back to Receiver Type")
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.newReceiver.hardwareType==='ATV4')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_el_form, {
            "hide-required-asterisk": "",
            class: "row text-left mt-5",
            model: _ctx.pairingCodeForm,
            ref: "pairingCodeForm",
            rules: _ctx.pairingCodeRules,
            "label-position": "top",
            onSubmit: _withModifiers(_ctx.onPair, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "col-md-6 p-0 pe-md-2 mb-md-4",
                label: "Pair Ditto tvOS Receiver with a Code",
                "data-test": "receiver-pair-tv-os-form"
              }, {
                label: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  prop: "pairingCode",
                  label: "Pair Ditto Receiver",
                  "data-test": "pair-ditto-receiver-tv-os-form"
                }, {
                  label: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_popover, {
                      trigger: "manual",
                      placement: "top-end",
                      width: 300,
                      offset: 30,
                      "popper-class": "onboarding__popover",
                      disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
                      visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && !_ctx.pairingCodeForm.pairingCode
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.pairingCodeForm.pairingCode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pairingCodeForm.pairingCode) = $event)),
                          placeholder: "Pairing Code",
                          class: _normalizeClass(["pairing-code-input", { 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.pairingCodeForm.pairingCode}]),
                          "data-test": "receiver-tv-os-pairing-code-input"
                        }, null, 8, ["modelValue", "class"])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["disabled", "visible"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_popover, {
                  trigger: "manual",
                  placement: "bottom-start",
                  "popper-class": "onboarding__popover width-auto",
                  disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.pairingCodeForm.pairingCode,
                  visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.pairingCodeForm.pairingCode
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _ctx.onPair,
                      type: "primary",
                      "data-test": "receiver-tv-os-pair-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Pair "),
                        (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.pairingCodeForm.pairingCode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["disabled", "visible"])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules", "onSubmit"])
        ]))
      : (_ctx.newReceiver.hardwareType==='DittoReceiver')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form, {
                class: "windows-pairing-options__two mt-4 mt-md-0 row",
                model: _ctx.generatePairingKeyForm,
                ref: "generatePairingKeyForm",
                rules: _ctx.generatePairingKeyRules,
                "label-position": "top",
                onSubmit: _withModifiers(_ctx.generatePairingKey, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "col-md-6 mb-0",
                    label: "Option One",
                    "data-test": "receiver-type-windows-option-one-form"
                  }, {
                    label: _withCtx(() => [
                      _hoisted_17
                    ]),
                    default: _withCtx(() => [
                      _hoisted_18,
                      _createVNode(_component_el_form_item, { class: "windows-receiver-name-form-item mt-0" }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_popover, {
                    trigger: "manual",
                    placement: "top-end",
                    "popper-class": "onboarding__popover",
                    width: 300,
                    disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
                    visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && !_ctx.generatePairingKeyForm.receiverName
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        class: "col-md-6 mb-0",
                        label: "Receiver Name"
                      }, {
                        label: _withCtx(() => [
                          _hoisted_20
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            class: "windows-receiver-name-form-item",
                            prop: "receiverName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: _normalizeClass(["col-md-6", { 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.generatePairingKeyForm.receiverName }]),
                                modelValue: _ctx.generatePairingKeyForm.receiverName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generatePairingKeyForm.receiverName) = $event)),
                                placeholder: "Enter a receiver name",
                                "data-test": "receiver-type-windows-option-one-receiver-name-input"
                              }, null, 8, ["class", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_popover, {
                            trigger: "manual",
                            placement: "right",
                            "popper-class": "onboarding__popover width-auto",
                            disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.generatePairingKeyForm.receiverName,
                            visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.generatePairingKeyForm.receiverName
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "mt-4",
                                type: "primary",
                                onClick: _ctx.generatePairingKey,
                                "data-test": "receiver-type-windows-option-one-generate-pairing-registry-key-button"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Generate Pairing Registry Key "),
                                  (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.generatePairingKeyForm.receiverName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["disabled", "visible"])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["disabled", "visible"])
                ]),
                _: 1
              }, 8, ["model", "rules", "onSubmit"]),
              _createVNode(_component_el_divider, {
                "content-position": "center",
                class: "my-5",
                "data-test": "receiver-type-windows-options-divider"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OR")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, {
                "hide-required-asterisk": "",
                class: "windows-pairing-options__one row",
                rules: _ctx.pairingCodeRules,
                model: _ctx.pairingCodeForm,
                ref: "pairingCodeForm",
                "label-position": "top",
                onSubmit: _withModifiers(_ctx.onPair, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Option Two",
                    class: "mb-4 col-lg-6",
                    "data-test": "receiver-type-windows-option-two-form"
                  }, {
                    label: _withCtx(() => [
                      _hoisted_24
                    ]),
                    default: _withCtx(() => [
                      _hoisted_25,
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_form_item, {
                      label: "Pairing Code",
                      prop: "pairingCode",
                      class: "mb-4"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_28
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_popover, {
                          trigger: "manual",
                          placement: "right",
                          "popper-class": "onboarding__popover",
                          width: 300,
                          disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
                          visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && !_ctx.pairingCodeForm.pairingCode
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: _normalizeClass([{ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.pairingCodeForm.pairingCode }, "windows__pairing-code-input"]),
                              modelValue: _ctx.pairingCodeForm.pairingCode,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pairingCodeForm.pairingCode) = $event)),
                              placeholder: "Enter Pairing Code",
                              "data-test": "receiver-type-windows-option-two-pairing-code-input"
                            }, null, 8, ["class", "modelValue"])
                          ]),
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }, 8, ["disabled", "visible"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_popover, {
                      trigger: "manual",
                      placement: "right",
                      "popper-class": "onboarding__popover width-auto",
                      disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.pairingCodeForm.pairingCode,
                      visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.pairingCodeForm.pairingCode
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          onClick: _ctx.onPair,
                          type: "primary",
                          "data-test": "receiver-type-windows-option-two-pair-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Pair "),
                            (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.pairingCodeForm.pairingCode)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }, 8, ["disabled", "visible"])
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model", "onSubmit"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_ctx.newReceiver.hardwareType==='ATV3')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35))
              : (_ctx.newReceiver.hardwareType === 'Chromecast')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_38))
                : (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_41)),
            _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.newReceiver.hardwareType), 1),
            _createVNode(_component_el_form, {
              "hide-required-asterisk": "",
              class: "row mt-5",
              model: _ctx.legacyOtherForm,
              ref: "legacyOtherForm",
              rules: _ctx.legacyOtherRules,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_el_form_item, {
                      class: "receiver-wizard__width-container",
                      label: "Receiver Name",
                      prop: "receiverName"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_44,
                        _createVNode(_component_el_input, {
                          class: _normalizeClass({ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.legacyOtherForm.receiverName }),
                          modelValue: _ctx.legacyOtherForm.receiverName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.legacyOtherForm.receiverName) = $event)),
                          placeholder: "Receiver Name",
                          "data-test": "receiver-type-other-name-input"
                        }, null, 8, ["class", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_form_item, { label: "Network Information" }, {
                    default: _withCtx(() => [
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_el_form_item, {
                          class: "col-md-6 p-0 pe-md-2",
                          label: "IP Address",
                          prop: "ipAddress"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: _normalizeClass({ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.legacyOtherForm.ipAddress }),
                              modelValue: _ctx.legacyOtherForm.ipAddress,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.legacyOtherForm.ipAddress) = $event)),
                              placeholder: "IP Address",
                              "data-test": "receiver-type-other-ip-address-input"
                            }, {
                              append: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: _ctx.helpLink,
                                  target: "_blank",
                                  rel: "noreferrer noopener"
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_48, [
                                    _createElementVNode("path", { d: _ctx.mdiHelpCircle }, null, 8, _hoisted_49)
                                  ]))
                                ], 8, _hoisted_47)
                              ]),
                              _: 1
                            }, 8, ["class", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "col-md-6 p-0 ps-md-2",
                          label: "MAC Address",
                          prop: "macAddress"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: _normalizeClass({ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.legacyOtherForm.macAddress }),
                              modelValue: _ctx.legacyOtherForm.macAddress,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.legacyOtherForm.macAddress) = $event)),
                              placeholder: "MAC Address",
                              "data-test": "receiver-type-other-mac-address-input"
                            }, {
                              append: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: _ctx.helpLink,
                                  target: "_blank",
                                  rel: "noreferrer noopener"
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_51, [
                                    _createElementVNode("path", { d: _ctx.mdiHelpCircle }, null, 8, _hoisted_52)
                                  ]))
                                ], 8, _hoisted_50)
                              ]),
                              _: 1
                            }, 8, ["class", "modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.newReceiver.hardwareType == 'Other')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createVNode(_component_el_form_item, {
                          class: "receiver-wizard__width-container",
                          label: "Connection Type",
                          prop: "connectionType"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_54,
                            _createVNode(_component_el_select, {
                              class: _normalizeClass({ 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.legacyOtherForm.connectionType.value}),
                              modelValue: _ctx.legacyOtherForm.connectionType.value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.legacyOtherForm.connectionType.value) = $event)),
                              placeholder: "Connection Type",
                              "data-test": "receiver-type-other-connection-type-dropdown"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectionTypes, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["class", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_popover, {
                    trigger: "manual",
                    placement: "left",
                    "popper-class": "onboarding__popover width-auto",
                    visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.showCreateReceiverClickTarget
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.onCreateReceiver
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Create Receiver "),
                          (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.showCreateReceiverClickTarget)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
  ]))
}